export default "__VITE_ASSET__DLFEwisG__"